import { Dialog, Button, Box, Typography, DialogContent } from "@material-ui/core";
import { openModal, closeModal } from "actions/modalActions";
import { setCopyModeAction } from "actions/scheduleActions";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { FC } from "react";
import { useDispatch } from "react-redux";
import { useModalStyles } from "./styles";
import Close from "@material-ui/icons/Close";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { CustomButton } from "componentsNew/buttons/CustomButton";
import { ScheduleReport } from "types/Schedule";

interface ModalWindowProps {
  buttonType: "icon" | "button" | "text" | "custom" | "none";
  children: any;
  modal_name: string;
  fullWidth?: boolean;
  buttonText?: string;
  modalTitle?: string;
  modalDescription?: string;
  isDisabled?: boolean;
  customButtonElement?: any;
  customOnClick?: any;
  theme?: "red";
  copyScheduleReport?: boolean;
  scheduleReport?: ScheduleReport;
}

export const ModalWindow: FC<ModalWindowProps> = ({
  buttonType,
  fullWidth,
  children,
  modal_name,
  buttonText,
  modalTitle,
  modalDescription,
  theme,
  isDisabled,
  customButtonElement,
  customOnClick,
  copyScheduleReport,
  scheduleReport,
}) => {
  const classes = useModalStyles();

  const dispatch = useDispatch();

  const { isOpen, modalName } = useTypeSelectors((state) => state.modalState);

  const triggerOnClick = () => {
    if (!customOnClick) {
      dispatch(openModal(modal_name));
    } else {
      dispatch(customOnClick);
    }
  };

  const handleHeaderIconClick = () => {
    if (copyScheduleReport && scheduleReport) {
      dispatch(setCopyModeAction(scheduleReport));
    }
    dispatch(closeModal());
  };

  return (
    <>
      {buttonType === "text" && (
        <Button
          className={classes.openBtn}
          variant="text"
          fullWidth={fullWidth}
          onClick={triggerOnClick}
          disabled={isDisabled}
        >
          {buttonText}
        </Button>
      )}{" "}
      {buttonType === "button" && (
        <CustomButton
          buttonText={String(buttonText)}
          variant="contained"
          onClick={triggerOnClick}
          disabled={isDisabled}
        />
      )}{" "}
      {buttonType === "custom" && (
        <Box
          className={`${classes.customButtonElement} ${isDisabled ? classes.disabledButton : ""}`}
          onClick={triggerOnClick}
        >
          {customButtonElement}
        </Box>
      )}
      <Dialog
        className={`${classes.root}`}
        open={isOpen && modalName === modal_name}
        onClose={() => dispatch(closeModal())}
        BackdropProps={{
          classes: {
            root: classes.backDrop,
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent className={`${classes.dialogTitle}`}>
          <Typography className={`${classes.title} ${theme ? classes[`${theme}Theme`] : ""}`}>
            {modalTitle}
          </Typography>
          <Button
            className={classes.closeBtn}
            variant="text"
            onClick={handleHeaderIconClick}
          >
            {copyScheduleReport ? <ContentCopyOutlinedIcon /> : <Close />}
          </Button>
        </DialogContent>
        {modalDescription ? (
          <DialogContent className={`${classes.dialogTitle}`}>
            <Typography className={classes.dialogText}>{modalDescription}</Typography>
          </DialogContent>
        ) : (
          ""
        )}
        {children}
      </Dialog>
    </>
  );
};
